import { MemberProps } from 'app/components/Core/convention'
import KUnit from 'app/components/Modules/DataDisplay/KUnit'
import * as React from 'react'

const QuantityUnitCell: React.FC<MemberProps<IInvoice | IInvoiceItem>> = ({ member }) => {
  if (member.__typename === 'InvoiceItem') {
    return <InvoiceItemQuantity member={member as IInvoiceItem} />
  }
  return null
}

function InvoiceItemQuantity({ member }: MemberProps<IInvoiceItem>) {
  if (member.quantity && member.unit) {
    return <KUnit member={member.unit} props={{ count: member.quantity }} />
  }

  return null
}

export default QuantityUnitCell
